import React from 'react';
import { motion } from 'framer-motion';
import { Download, PlayCircle, MessageCircle, ShieldCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-brand-gold" data-id="element-91" />,
    title: 'Descarga el Plan',
    desc: 'Recibes el acceso inmediato a los archivos PDF tras el pago.'
  }, {
    icon: <PlayCircle className="w-8 h-8 text-brand-gold" data-id="element-92" />,
    title: 'Aplica los 7 Días',
    desc: 'Sigue una tarea diaria sencilla (máximo 45 min por día).'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-brand-gold" data-id="element-93" />,
    title: 'Recibe Prospectos',
    desc: "Mira cómo tu bandeja de entrada empieza a llenarse de personas preguntando: '¿De qué trata tu proyecto?'."
  }];
  return;
}